import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Pagination = ({
                        currentPage,
                        itemsPerPage,
                        totalItems,
                        onPageChange,
                        onPageSizeChange
                    }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const pages = [...Array(totalPages).keys()].map((i) => i + 1);

    const handlePageChange = (pageNumber) => {
        if (pageNumber !== currentPage) {
            onPageChange(pageNumber);
        }
    };

    const handlePageSizeChange = (event) => {
        const pageSize = parseInt(event.target.value, 10);
        onPageSizeChange(pageSize);
    };

    const renderPageItem = (pageNumber, label) => {
        const active = pageNumber === currentPage;
        const classes = classNames(
            'inline-flex items-center justify-center min-w-[2rem] h-8 px-2 mr-1 rounded-lg text-sm font-medium transition-colors',
            {'bg-pink-600 text-white shadow-sm' : active},
            {'text-gray-600 hover:bg-gray-100' : !active},
        );
        return (
            <button
                key={pageNumber}
                className={classes}
                onClick={() => handlePageChange(pageNumber)}
                disabled={active}
            >
                {label ? label : pageNumber}
            </button>
        );
    };

    const renderPageSizeSelector = () => (
        <select
            className="inline-block py-1.5 px-3 rounded-lg border border-gray-300 text-sm"
            value={itemsPerPage}
            onChange={handlePageSizeChange}
        >
            <option value={10}>10 per page</option>
            <option value={20}>20 per page</option>
            <option value={50}>50 per page</option>
            <option value={100}>100 per page</option>
        </select>
    );

    const renderPaginationInfo = () => {
        const from = (currentPage - 1) * itemsPerPage + 1;
        const to = Math.min(currentPage * itemsPerPage, totalItems);
        return (
            <p className="text-sm text-gray-500">
                Showing {from} to {to} of {totalItems} entries
            </p>
        );
    };

    const renderPaginationControls = () => (
        <div className="flex items-center">
            {currentPage > 3 && <span className="mx-2 text-gray-400">...</span>}
            {pages
                .filter((page) => page >= currentPage - 2 && page <= currentPage + 2)
                .map((page) => renderPageItem(page))}
            {currentPage < totalPages - 2 && <span className="mx-2 text-gray-400">...</span>}
        </div>
    );

    return (
        <div className="flex flex-wrap items-center justify-between gap-3">
            <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-600">Show:</span>
                {renderPageSizeSelector()}
            </div>
            <div>{renderPaginationInfo()}</div>
            <div>{renderPaginationControls()}</div>
        </div>
    );
};

Pagination.propTypes = {
    currentPage      : PropTypes.number.isRequired,
    itemsPerPage     : PropTypes.number.isRequired,
    totalItems       : PropTypes.number.isRequired,
    onPageChange     : PropTypes.func.isRequired,
    onPageSizeChange : PropTypes.func.isRequired,
};

export default Pagination;